// extracted by mini-css-extract-plugin
export default {"labelStyle":"UserAddFoto_labelStyle__aClyL"};